"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    statusSharedColors: ()=>statusSharedColors,
    personaSharedColors: ()=>personaSharedColors
});
const _colors = require("./colors");
const statusSharedColors = {
    red: _colors.red,
    green: _colors.green,
    darkOrange: _colors.darkOrange,
    yellow: _colors.yellow,
    berry: _colors.berry,
    lightGreen: _colors.lightGreen,
    marigold: _colors.marigold
};
const personaSharedColors = {
    darkRed: _colors.darkRed,
    cranberry: _colors.cranberry,
    pumpkin: _colors.pumpkin,
    peach: _colors.peach,
    gold: _colors.gold,
    brass: _colors.brass,
    brown: _colors.brown,
    forest: _colors.forest,
    seafoam: _colors.seafoam,
    darkGreen: _colors.darkGreen,
    lightTeal: _colors.lightTeal,
    teal: _colors.teal,
    steel: _colors.steel,
    blue: _colors.blue,
    royalBlue: _colors.royalBlue,
    cornflower: _colors.cornflower,
    navy: _colors.navy,
    lavender: _colors.lavender,
    purple: _colors.purple,
    grape: _colors.grape,
    lilac: _colors.lilac,
    pink: _colors.pink,
    magenta: _colors.magenta,
    plum: _colors.plum,
    beige: _colors.beige,
    mink: _colors.mink,
    platinum: _colors.platinum,
    anchor: _colors.anchor
}; //# sourceMappingURL=colorPalette.js.map

//# sourceMappingURL=colorPalette.js.map